import { Chip } from '@mui/material';
import { useCaseFieldData } from '../../../hooks/useCaseField';
import type { FieldMode } from '../../../hooks/useCaseField';
import { getStatusDisplayName, toMedNecStatus, getStatusConfig } from '../../../utils/statusConfig';

const StatusChip: React.FC<{ mode: FieldMode }> = ({ mode }) => {
  const data = useCaseFieldData(mode);
  const displayName = getStatusDisplayName(data.status);
  const medNecStatus = toMedNecStatus(data.status);
  const config = medNecStatus ? getStatusConfig(medNecStatus) : undefined;

  return (
    <Chip
      label={displayName || 'Unknown'}
      size="small"
      sx={config ? {
        backgroundColor: config.bgColor,
        color: config.color,
        fontWeight: 600,
      } : undefined}
    />
  );
};

export default StatusChip;